import { FC, PropsWithChildren, useEffect, useRef, useState } from "react"
import { observer } from "mobx-react"
import { Button, ButtonProps, Form, FormInstance } from "antd"

interface SubmitButtonProps extends PropsWithChildren {
  buttonProps?: ButtonProps
  form: FormInstance
}
export const SubmitButton = observer(
  ({
    buttonProps = {
      size: "middle",
      type: "primary",
    },
    children,
    form,
  }: SubmitButtonProps) => {
    const [submittable, setSubmittable] = useState<boolean>(false)

    // Watch all values
    const values = Form.useWatch([], form)

    useEffect(() => {
      form
        .validateFields({ validateOnly: true })
        .then(() => setSubmittable(true))
        .catch(() => setSubmittable(false))
    }, [form, values])

    return (
      <Button
        htmlType="submit"
        {...buttonProps}
        disabled={!submittable || Boolean(buttonProps.disabled)}
        id="GENERATED_ID_SUBMITBUTTON_BUTTON_VOID_1"
      >
        {children}
      </Button>
    )
  },
)
